import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';

declare const reviewsBadgeModern: any;

@Component({
    selector: 'app-full-layout',
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss'],
})
export class FullComponent implements OnInit {
    constructor(
        private apiService: ApiService,
        private dataService: DataService,
    ) {}

    ngOnInit() {
        reviewsBadgeModern('badge-230', {
            store: 'harry-hall',
            primaryClr: '#202440',
            starsClr: '#0076a5',
        });

        const w = window as any;
        const previousReady = w.$zoho?.salesiq?.ready;
        w.$zoho = w.$zoho || {};
        w.$zoho.salesiq = w.$zoho.salesiq || {};
        w.$zoho.salesiq.ready = () => {
            if (typeof previousReady === 'function') {
                previousReady();
            }
            w.$zoho.salesiq.floatbutton?.click?.(() => this.onOffSiteClick('chat-box'));
            w.$zoho.salesiq.visitor?.callback?.(() => this.onOffSiteClick('callback-form'));
        };
    }

    onOffSiteClick(url: string) {
        const email = this.dataService.getQuote()?.email;
        console.log('offsiteclick');
        if (email) {
            this.apiService.klaviyoSendEvent({ type: 'off-site', url, email }).subscribe();
        }
    }
}
